import React from "react";
import { Button, FormLabel, Row, Table, Col } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import {
  FabricStyleCostAndPriceMaintenanceBean,
  FabricStyleCostAndPriceMaintenanceLineBean,
  FabricStyleCostMaintenanceSearchCriteria,
  RestEntityUnLockRequest,
  RestFabricStyleCostMaintenanceListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricCostLookupHandler } from "../lookup/FabricCostLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ConfigManager } from "../config/ConfigManager.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricStyleCostMaintenance extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "",

      pageList: new RestPageListBean(),
      costData: new FabricStyleCostAndPriceMaintenanceBean(),
      criteria: new FabricStyleCostMaintenanceSearchCriteria(),
      isLoading: false,

      isShowSaveButton: false,
      isShowClearErrorButton: false,

      isEntryFormOpen: true,
      isListFormOpen: false,
      error_list: [],

      nodeList: [],
      selectedNodeKey: "headerView",
      isShowNodes: false,

      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      inventoryAdjustmentLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      isResetView: true,
      order: "asc",
      sortField: "",
      isViewMode: false,
      isShowProgressBarPopup: false,
      selectedDocument: "",
      selectedList: new Array(),
      isSpecialViewMode: false,
      isViewMode: false,
      isMaintenanceMode: true,
      fabricCostList: new Array(),
      isDisabledFields: false,
      is3PL: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  //moduleCaption = "FabricStyle Cost Maintenance";
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (this.state.is3PL === true) {
      this.moduleCaption = "Item Cost Maintenance";
    } else {
      this.moduleCaption = "FabricStyle Cost Maintenance";
    }
    this.initLookupHandlers();

    this.addNewEntry();
  }
  initLookupHandlers = () => {
    let fabricStyleCostLookupHandler = new FabricCostLookupHandler(
      this.companyCode,
      this.state.is3PL ? "ItemCost" : "FabricStyleCost"
    );
    this.setState({
      fabricStyleCostLookupHandler: fabricStyleCostLookupHandler,
    });
  };
  /* open InventoryAdjustment entry form*/
  openEntryForm = () => {
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearErrorButton: true,
      isMaintenanceMode: false,
      isResetView: false,
      isShowModuleSearchContainer: true,
      isDisabledFields: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        disabled: true,
        pageTitle: pageTitle,
        isDisabledFields: true,
      });
    }
    let costData = this.state.costData;
    if (costData.isFetched) {
      this.setState({
        isShowSaveButton: false,
        isDisabledFields: true,
      });
    }
  };
  /* close InventoryAdjustment entry form*/
  closeEntryForm = () => {
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearErrorButton: false,

      pageTitle: pageTitle,
      moduleKeyCode: "NEW",
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isViewMode: false,
      isShowModuleSearchContainer: false,
      isDisabledFields: false,
    });
  };
  getListResponse = (response) => {
    console.log("response :: ", response);
    let fabricCostList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStyleCostMaintenancePageList) &&
      !isEmptyArray(
        response.data.fabricStyleCostMaintenancePageList
          .fabricStyleCostMaintenanceBeans
      )
    ) {
      fabricCostList =
        response.data.fabricStyleCostMaintenancePageList
          .fabricStyleCostMaintenanceBeans;
      this.state.pageList.totalCount =
        response.data.fabricStyleCostMaintenancePageList.totalCount;
      this.state.pageList.currentPage =
        response.data.fabricStyleCostMaintenancePageList.currentPage;
    }
    this.setState({
      fabricCostList: fabricCostList,
      isLoading: false,
      loadingText: "",
    });
  };
  loadFabricCostPage = () => {
    let request = new RestFabricStyleCostMaintenanceListRequest();
    request.pageInput = this.state.pageList;
    const criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    request.searchCriteria = criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.FabricStyleCostSheetMaintenance_IsAccessible()) {
      FabricStyleService.getFabricStyleCostMaintenancePageList(
        request,
        this.getListResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  filterFabricCost = () => {
    this.loadPage(1);
  };
  resetfilteredFabricCost = (criteria) => {
    criteria = new FabricStyleCostMaintenanceSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.criteriakey = "";
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  searchOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria["costMaintenanceNumberContains"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadFabricCostPage();
  };
  addNewEntry = () => {
    let costData = new FabricStyleCostAndPriceMaintenanceBean();
    costData.companyCode = this.companyCode;
    costData.code = "NEW";
    // inventoryAdjustmentData.locationCode = DEFAULT_WAREHOUSE;
    let pageTitle = this.moduleCaption + " - NEW";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      costData.code = this.state.moduleKeyCode;
    } else costData.code = NEW_ENTRY;

    this.setState({
      costData: costData,
      pageTitle: pageTitle,
    });
    // this.state.selectedNodeKey = "headerView";

    this.openEntryForm();
  };

  getModuleListView = () => {
    // let costData = this.state.costData;
    // if (costData.code === NEW_ENTRY) {
    //   this.closeEntryForm();
    //   this.loadPage(1);
    // } else {
    //   if (this.isLocked) {
    //     this.isLocked = false;
    //     if (!this.state.isViewMode) this.unLockFabricCost(costData.code);
    //   } else {
    //     this.isLocked = false;
    //   }

    this.closeEntryForm();
    this.loadPage(1);
    // }
  };

  resetView = () => {
    let _costData = this.state.costData;
    this.state.isReseted = true;
    // if (this.isLocked) {
    //   this.isLocked = false;
    //   if (!this.state.isViewMode) this.unLockFabricCost(_costData.code);
    // } else {
    //   this.isLocked = false;
    // }
    let costData = new FabricStyleCostAndPriceMaintenanceBean();

    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.setState({
      isShowAlert: false,
      isResetModule: true,
      disabled: false,
      costData: costData,
      isShowInvoiceLookup: false,
      isDisabledFields: false,
    });
    this.state.costData = costData;
    this.hideAlertCallBack();

    this.clearError();
    this.addNewEntry();
  };
  clearError = () => {
    this.setState({ error_list: new Array() });
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  moduleExit = () => {
    // let costData = this.state.costData;
    // if (costData.code === NEW_ENTRY) {
    //   this.props.onModuleExit();
    // } else {
    //   if (this.isLocked) {
    //     this.isLocked = false;
    //     if (!this.state.isViewMode) this.unLockFabricCost(costData.code);
    //   } else {
    //     this.isLocked = false;
    //   }

    this.props.onModuleExit();
    // }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  selectButtonClick = (e) => {
    this.editFabricCost(this.state.moduleKeyCode);
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  getDataLines = (lines) => {
    let costData = this.state.costData;
    costData.companyCode = this.companyCode;
    let lineNumber = 0;
    let costLines = new Array();
    for (let data of lines) {
      let costLineData = new FabricStyleCostAndPriceMaintenanceLineBean();
      costLineData.companyCode = this.companyCode;
      costLineData.costMaintenanceNumber = costData.code;
      costLineData.fabricStyleCode = data.fabricStyleCode;
      costLineData.fabricStyleName = data.fabricStyleName;
      costLineData.fabricStyleColorCode = data.fabricStyleColorCode;
      costLineData.widthCode = data.widthCode;
      costLineData.productTypeCode = data.productTypeCode;
      costLineData.patternTypeCode = data.patternTypeCode;
      costLineData.patternTypeCategoryCode = data.patternTypeCategoryCode;
      costLineData.makeTypeCode = data.makeTypeCode;
      costLineData.skuNumber = data.skuNumber;
      costLineData.uomCode = data.uomCode;
      costLineData.cost = data.cost;
      costLineData.price = data.price;
      if (costLineData.price == null) {
        costLineData.price = 0;
      }
      costLineData.lineNumber = ++lineNumber;
      costLines.push(costLineData);
    }
    costData.costPriceLines = costLines;
    this.setState({ costData: costData });
  };
  getLineDataExcelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.costPriceMaintenanceBean)
    ) {
      if (
        !isEmptyArray(response.data.costPriceMaintenanceBean.costPriceLines)
      ) {
        let costLines = new Array();
        costLines = response.data.costPriceMaintenanceBean.costPriceLines;
        this.getDataLines(costLines);
      }
    }
  };
  getDatasFromExcel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading Excel Data",
    });
    let selectedDocument = this.state.selectedDocument;
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = selectedDocument;

    if (SecurityAccessManager.FabricStyleCostSheetMaintenance_IsAccessible()) {
      FabricStyleService.getFabricStyleWithCostMaintenanceInputFromExcel(
        readrestInput,
        this.getLineDataExcelResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadExcelFile = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ selectedDocument: fileName });
    if (SecurityAccessManager.FabricStyleCostSheetMaintenance_IsAccessible()) {
      FabricStyleService.FabricStyleExcelUpload(
        formData,
        this.uploadExcelResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getDatasFromExcel();
      }
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
  };
  selectAllLines = (e) => {
    if (e.detail == 1) {
      let costData = this.state.costData;
      let list = new Array();
      if (!isEmptyArray(costData.costPriceLines)) {
        list = costData.costPriceLines;
        list.map((line) => {
          line.isApplied = true;
          // if(line.isApplied){
          //   costData.costPriceLines.push(line);
          // }
        });
        this.setState({ selectedList: list });
      }
    }
  };
  unSelectAllLines = (e) => {
    if (e.detail == 1) {
      let costData = this.state.costData;
      let list = new Array();
      if (!isEmptyArray(costData.costPriceLines)) {
        list = costData.costPriceLines;
        list.map((line) => {
          line.isApplied = false;
        });
        this.setState({ selectedList: [] });
      }
    }
  };
  costLineCheck = (val, rowData) => {
    let selectedLine = this.state.selectedList;
    if (rowData.isApplied === true) {
      selectedLine.push(rowData);
      this.setState({ selectedList: selectedLine });
    } else {
      let selectedList = this.state.selectedList;
      let costList = [];
      for (let ln of selectedList) {
        if (ln.isApplied != rowData.isApplied) {
          costList.push(ln);
          this.setState({ selectedList: costList });
        } else if (selectedList.length == 1) {
          this.setState({ selectedList: [] });
        }
      }
    }
  };
  saveCostResponse = (response) => {
    this.handleResponse(response.data);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.costPriceMaintenanceBean)
    ) {
      let costData = response.data.costPriceMaintenanceBean;

      this.setState({ costData: costData });
      this.editFabricCost(costData.code);
    }
  };
  saveFabricStyleCost = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let costData = this.state.costData;
    costData.companyCode = this.companyCode;

    if (SecurityAccessManager.FabricStyleCostSheetCreation_IsAccessible()) {
      FabricStyleService.createFabricStyleCostMaintenance(
        costData,
        this.saveCostResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  validateData = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyArray(data.costPriceLines)) {
        let errMsg = "CostPriceLine is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      } else {
        let dataLine = data.costPriceLines.filter((ln) => ln.isApplied == true);
        if (dataLine.length <= 0) {
          let errMsg = "Select Lines";
          errorMessage = errorMessage + errMsg;
          err_list.push(errMsg);
        }
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  save = () => {
    let costData = this.state.costData;
    let isValid = this.validateData(costData);
    if (isValid) {
      this.saveFabricStyleCost();
    }
  };

  readFabricCostResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.costMaintenanceResponse != null) {
      if (response.data.costMaintenanceResponse.errors != null) {
        response.data.costMaintenanceResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    // if (
    //   errMsg !=
    //   " FabricStyle CostMaintenance " +
    //     this.state.moduleKeyCode +
    //     " Not Read Sucessfully "
    // ) {
    if (!errMsg.includes("Not Read"))
      this.showErrorMessage(response.data.costMaintenanceResponse);
    // }
    if (response.data.isSuccess == true) {
      this.setState({ isLoading: false, loadingText: "" });
      if (
        response.data.costMaintenanceResponse != null &&
        response.data.costMaintenanceResponse.costPriceMaintenanceBean != null
      ) {
        const costData =
          response.data.costMaintenanceResponse.costPriceMaintenanceBean;
        let pageTitle = this.moduleCaption + " - VIEW";
        let moduleKeyCode = costData.code;
        // this.clearError();
        this.state.costData = costData;

        this.setState({
          costData: costData,
          pageTitle: pageTitle,
          isShowNodes: true,
          moduleKeyCode: moduleKeyCode,
          isLoading: false,
          loadingText: "",
          selectedNodeKey: "headerView",
        });
        this.isLocked = true;
        // this.getNodeList();
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  editFabricCost = (code) => {
    const readrequest = new RestReadRequest();
    readrequest.code = code;
    readrequest.companyCode = this.companyCode;
    readrequest.isLoadChildren = true;
    let isLockRequired = NEW_ENTRY === code ? false : true;
    readrequest.isLockRequired = isLockRequired;
    if (SecurityAccessManager.FabricStyleCostSheetView_IsAccessible()) {
      FabricStyleService.initFabricStyleCostMaintenanceModule(
        readrequest,
        this.readFabricCostResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let fabricCostList = this.state.fabricCostList;
    if (sortField && !isEmptyArray(fabricCostList)) {
      const sorted = [...fabricCostList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ fabricCostList: sorted });
    }
  };
  unlockResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editFabricCost(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unLockFabricCost = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.FabricStyleCostSheetMaintenance_IsAccessible()) {
      FabricStyleService.unLockFabricStyleCostMaintenanceCode(
        request,
        this.unlockResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onExcelClick = (e) => {
    if (e.detail <= 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };
  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editFabricCost}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.fabricStyleCostLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          isSpecialViewMode={this.state.isSpecialViewMode}
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isResetView={this.state.isResetView}
        />
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              pageTitle={this.state.pageTitle}
            />
          )}
        {this.state.isListFormOpen && this.state.isSpecialViewMode == false && (
          <FabricCostMaintenanceListForm
            {...this.state}
            fabriccostlist={this.state.fabricCostList}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            filterFabricCost={this.filterFabricCost}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            editFabricCost={this.editFabricCost}
            resetfilteredFabricCost={this.resetfilteredFabricCost}
            isLoading={this.state.isLoading}
            searchOnChange={this.searchOnChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {this.state.isEntryFormOpen && (
          <FabricCostMaintenanceEntryForm
            {...this.state}
            uploadExcelFile={this.uploadExcelFile}
            costLineCheck={this.costLineCheck}
            selectAllLines={this.selectAllLines}
            unSelectAllLines={this.unSelectAllLines}
            onExcelClick={this.onExcelClick}
          />
        )}
        {/* <input
          type="file"
          id="file-input"
          style={{ display: "none" }}
          onChange={this.uploadExcelFile}
          accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
        /> */}
      </div>
    );
  }
}
class FabricCostMaintenanceListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  searchOnChange = (e) => {
    this.props.searchOnChange(e);
  };
  filterFabricCost = (e) => {
    if (e.detail == 1) this.props.filterFabricCost();
  };
  resetfilteredFabricCost = (e) => {
    let criteria = this.props.criteria;
    if (e.detail == 1) this.props.resetfilteredFabricCost(criteria);
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editFabricCost = (e, val, rowData) => {
    if (e.detail == 1) this.props.editFabricCost(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterFabricCost();
    }
  };
  render() {
    let fabriccostlist = this.props.fabriccostlist;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let isLoading = this.props.isLoading;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="costMaintenanceNumberContains"
                type="text"
                value={criteria.costMaintenanceNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.searchOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterFabricCost(e)}>Filter</Button>
              <Button onClick={(e) => this.resetfilteredFabricCost(e)}>
                Reset
              </Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_Custom_2">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "code" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Description
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>

                <th onClick={(e) => this.handleSortingChange(e, "createdDate")}>
                  CreatedDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {fabriccostlist != null ? (
              <tbody>
                {fabriccostlist.map((inv, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editFabricCost(e, inv.code)}
                      >
                        {inv.code}
                      </Button>
                    </td>
                    <td>{inv.description}</td>
                    <td>{inv.createdDate}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {fabriccostlist.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class FabricCostMaintenanceEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  onExcelClick = (e) => {
    this.props.onExcelClick(e);
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  fabricCostColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isApplied", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.props.costLineCheck,
          null
        )
        .setDisabled(this.props.isDisabledFields)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
      //  .setClickDetails(true, false, this.lnkARModule,null )
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
      // .setClickDetails(true, false, this.lnkCustomerModule,null )
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sku", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Style", "productTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "patternTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Content", "makeTypeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Categories", "patternTypeCategoryCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cost", "cost", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isApplied",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.props.costLineCheck
        )
        .setDisabled(this.props.isDisabledFields)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Ln#", "lineNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Item" : "FabricStyle",
        "fabricStyleCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "ItemName" : "FabricStyleName",
        "fabricStyleName"
      )
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "fabricStyleColorCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Sku", "skuNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM", "uomCode")
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails("Width", "widthCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Style", "productTypeCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Type", "patternTypeCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Content", "makeTypeCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Categories",
        "patternTypeCategoryCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Cost", "cost", 1)
    );
    return columnList;
  };
  render() {
    let costData = this.props.costData;
    let costLines = new Array();
    if (!isEmptyArray(costData.costPriceLines))
      costLines = costData.costPriceLines;
    return (
      <div>
        <Row>
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              onClick={(e) => this.props.selectAllLines(e)}
              disabled={this.props.isDisabledFields}
            >
              Select All
            </Button>
          </Col>

          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              onClick={(e) => this.props.unSelectAllLines(e)}
              disabled={this.props.isDisabledFields}
            >
              UnSelect All
            </Button>
          </Col>
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm"
              onClick={(e) => this.onExcelClick(e)}
              disabled={this.props.isDisabledFields}
            >
              Load From Excel
            </Button>
            <input
              type="file"
              id="file-input"
              style={{ display: "none" }}
              onChange={this.uploadExcelFile}
              accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
            />
          </Col>
        </Row>
        <div className="div_default">
          {/* <Table id="fabrics_tables">
            <thead>
              <tr>
                <th></th>
                <th>Ln#</th>
                <th>FabricStyle#</th>
                <th>FabricStyle Name</th>
                <th>Color</th>
                <th>Sku</th>
                <th>UOM</th>
                <th>Width</th>
                <th>Style</th>
                <th>Type</th>
                <th>Content</th>
                <th>Categories</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody></tbody>
          </Table> */}
          {/* <EditableDataGrid
            columnsList={this.columnDefinitions()}
            dataList={costLines}
          /> */}
          <CustomTable columns={this.fabricCostColumns()} data={costLines} />
        </div>
      </div>
    );
  }
}

function FabricStyleCostMaintenanceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <FabricStyleCostMaintenance {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default FabricStyleCostMaintenanceModule;
